import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Manages body scroll lock for modals and overlays.
 * Centralised to avoid scattered document.body.style mutations.
 */
@Injectable({ providedIn: 'root' })
export class ScrollLockService {
  private platformId = inject(PLATFORM_ID);
  private lockCount = 0;
  private originalOverflow = '';
  private originalPaddingRight = '';

  lock(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    if (this.lockCount === 0) {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      this.originalOverflow = document.body.style.overflow;
      this.originalPaddingRight = document.body.style.paddingRight;

      document.body.style.overflow = 'hidden';
      // Compensate for scrollbar disappearance so layout doesn't shift
      if (scrollBarWidth > 0) {
        document.body.style.paddingRight = `${scrollBarWidth}px`;
      }
    }
    this.lockCount++;
  }

  unlock(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    if (this.lockCount > 0) {
      this.lockCount--;
    }
    if (this.lockCount === 0) {
      document.body.style.overflow = this.originalOverflow;
      document.body.style.paddingRight = this.originalPaddingRight;
    }
  }
}
